import { $$, $, closest } from '../../../shared/js/utils/dom';
import { Swiper } from 'swiper';
import { A11y } from './modules/a11y/a11y.mjs';
import { addPageheaderSlider } from './slider-pageheader';
import {
  Navigation,
  Pagination,
  EffectCreative,
  Autoplay,
  Thumbs,
} from 'swiper/modules';
import merge from 'deepmerge';
import Bus from '../../../shared/js/modules/event-bus';

class Slider {
  constructor(params) {
    this.el = params.el;
    this.children = this.el.querySelectorAll('.swiper-slide');
    this.config = {
      modules: [Navigation, Pagination, A11y, EffectCreative, Autoplay, Thumbs],
      loop: true,
      init: false,
      speed: 900,
      grabCursor: true,
      resistanceRatio: 0.1,
      pagination: {
        el: '.swiper-pagination',
      },
      touchEventsTarget: 'swiper-slide',
    };

    this.galleryConfig = {
      slidesPerView: 1,
      loop: false,
      breakpoints: {
        745: {
          slidesPerView: 2,
        },
      },
      effect: 'creative',
      creativeEffect: {
        limitProgress: 2,
        prev: {
          translate: ['-100%', 0, 0],
          origin: 'left bottom',
          scale: 0.8,
        },
        next: {
          translate: ['100%', 0, 0],
          origin: 'right bottom',
          scale: 0.8,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next--gallery',
        prevEl: '.swiper-button-prev--gallery',
      },
      pagination: {
        type: 'fraction',
        renderFraction: function (currentClass, totalClass) {
          return (
            '<span class="sr-only">Inhalt</span><span class="' +
            currentClass +
            ' slider__pagination-counter-current"></span>' +
            ' <span aria-hidden="true">|</span><span class="sr-only">von</span> ' +
            '<span class="' +
            totalClass +
            ' slider__pagination-counter-total"></span>'
          );
        },
      },
    };
    this.teaserConfig = {
      slidesPerView: 1,
      spaceBetween: 35,
      breakpoints: {
        745: {
          slidesPerView: 2,
          spaceBetween: 60,
        },
        1025: {
          slidesPerView: 2.5,
          spaceBetween: 35,
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: false,
    };
    this.teaserCompactConfig = {
      slidesPerView: 'auto',
      // slidesPerView: 1,
      spaceBetween: 35,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: false,
    };
    this.categoryConfig = {
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 35,
      pagination: {
        type: 'custom',
        clickable: true,
        el: '.slider__controls--category',
        renderCustom: function (el, current, total) {
          const names = [];
          $$('.slider--category .slider__slide').forEach(el => {
            const dataName = el.getAttribute('data-name');
            names.push(dataName);
          });

          let text = '';
          for (let i = 1; i <= total; i++) {
            if (current !== i) {
              text +=
                "<button class='slider__pagination-button swiper-pagination-bullet swiper-pagination-clickable' data-index='" +
                i +
                "'>" +
                names[i - 1] +
                '</button>';
            } else {
              text +=
                "<button class='slider__pagination-button slider__pagination-button--active swiper-pagination-bullet swiper-pagination-clickable' data-index='" +
                i +
                "'>" +
                names[i - 1] +
                '</button>';
            }
          }
          return text;
        },
      },
      navigation: {
        nextEl: '.swiper-button-next--category',
        prevEl: '.swiper-button-prev--category',
      },
    };
    this.isCompactVariant = closest(this.el, '.dossier');
    this.isGallerySlider = this.el.dataset.sliderPreset === 'gallery';
    this.isTeaserSlider =
      !this.isCompactVariant && this.el.dataset.sliderPreset === 'teaser';
    this.isTeaserSliderCompact =
      this.isCompactVariant && this.el.dataset.sliderPreset === 'teaser';
    this.isCategorySlider = this.el.dataset.sliderPreset === 'category';
    this.swiperInstance = undefined;
  }

  init() {
    this.eventBinding();
    this.classBinding();
    this.initSwiper();
  }

  initSwiper() {
    this.updateConfig();

    this.swiperInstance = new Swiper(this.el, {
      ...this.config,
    });

    this.swiperInstance.init();
  }

  updateConfig() {
    if (this.reducedMotionIsActive) this.config.loop = false;

    if (this.isGallerySlider)
      this.config = merge(this.config, this.galleryConfig);
    if (this.isTeaserSlider)
      this.config = merge(this.config, this.teaserConfig);
    if (this.isTeaserSliderCompact)
      this.config = merge(this.config, this.teaserCompactConfig);
    if (this.isCategorySlider)
      this.config = merge(this.config, this.categoryConfig);
  }

  eventBinding() {
    if (
      this.isGallerySlider ||
      this.isPageHeaderSlider ||
      this.isPageHeaderSliderThumb ||
      this.isTeaserSlider ||
      this.isCategorySlider
    )
      Bus.subscribe(
        'resize',
        'MediaGalleryResize',
        this.onResizeHandler.bind(this)
      );
  }

  classBinding() {
    this.el.classList.add(`slider--${this.children.length}-items`);
  }

  onResizeHandler() {
    if (
      this.isGallerySlider ||
      this.isPageHeaderSlider ||
      this.isPageHeaderSliderThumb ||
      this.isTeaserSlider ||
      this.isCategorySlider
    ) {
      this.restartSlider();
    }
  }

  restartSlider() {
    this.swiperInstance.on('destroy', () => {
      this.initSwiper();
    });
    this.swiperInstance.destroy();
  }
}

const toggleAutoplayButton = (event, instance) => {
  const currentAutoplayButton = event.target.closest(
    '.slider__autoplay-button'
  );

  if (instance.autoplay.running) {
    instance.autoplay.stop();
    currentAutoplayButton.classList.remove('is-running');
  } else {
    instance.autoplay.start();
    currentAutoplayButton.classList.add('is-running');
  }
};

const initAutoplayButton = instance => {
  const autoplayButton = $('.slider__autoplay-button', instance.el);

  if (!autoplayButton) return;
  if (instance.autoplay.running) autoplayButton.classList.add('is-running');

  autoplayButton.addEventListener('click', event => {
    toggleAutoplayButton(event, instance);
  });
};

// for the pageheader there are 2 Swiper instances getting called, on sync outside of the class Slider

const pageheadSliders = $$('.slider--pageheader');

pageheadSliders.length &&
  pageheadSliders.forEach(el => {
    const { mainPageheaderSlider } = addPageheaderSlider();
    initAutoplayButton(mainPageheaderSlider);
  });

/// /////////////////////////////////////////////////

const sliders = $$('.swiper:not(.slider--quiz)');
const sliderInstances = [];

sliders.forEach(el => {
  const sliderInstance = new Slider({
    el,
  });
  sliderInstances.push(sliderInstance);
  sliderInstance.init();
});
